import * as React from 'react';
import styles from './index.less';

/**
 * 404 页面
 */
export default class NotFound extends React.Component {
  render() {
    return (
      <div className={styles.root}>
        <p className={styles.text}>您访问的页面不见了/(ToT)/~~</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/not-found/index.js